;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.product.show')
    .controller('ModifyPriceModalController', ModifyPriceModalController)

  ModifyPriceModalController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function ModifyPriceModalController (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this
    let percentage = 0
    let hasClientConditions = false

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        percentage: percentage,
        hasClientConditions: hasClientConditions,
        // Public Method
        invalidValue: invalidValue
      })
    }

    function invalidValue () {
      return self.percentage <= -100
    }
  }
})(window.angular, window._)
